/**
 * Note: This base selector type was taken from the Reselect project.
 * @see https://github.com/reduxjs/reselect/blob/32b66389b9fbf546690f89b0ec1bb05dbf6d3463/src/types.ts#L10-L26
 *
 * A standard selector function, which takes three generic type arguments:
 *
 * @param State The first value, often a Redux root state object
 * @param Result The final result returned by the selector
 * @param Params All additional arguments passed into the selector
 */

export const basicSelectorWithStats = basicUnmemoizedSelector => {
  return basicUnmemoizedSelector;
};
export const basicSelector = basicUnmemoizedSelector => {
  return basicUnmemoizedSelector;
};
export const getIsSelectorWithStats = selector => {
  if (typeof selector !== 'function') {
    return false;
  }
  const tmp = selector;
  return Array.isArray(tmp.dependencies) && typeof tmp.notMemoized === 'boolean' && typeof tmp.durations === 'function' && typeof tmp.recomputations === 'function' && typeof tmp.resetDurations === 'function' && typeof tmp.resetRecomputations === 'function' && typeof tmp.resultFunc === 'function';
};

/** Extracts the first parameter type from a selector function. */

/** Extracts all parameters except the first from a selector function. */

export function makeGatedSelector(gateCheckSelector, gatedSelector, ungatedSelector) {
  const wrappedSelector = function wrappedSelector() {
    // @ts-ignore using arguments for perf
    // eslint-disable-next-line
    if (gateCheckSelector.apply(null, arguments)) {
      // @ts-ignore using arguments for perf
      // eslint-disable-next-line
      return ungatedSelector.apply(null, arguments);
    }
    // @ts-ignore using arguments for perf
    // eslint-disable-next-line
    return gatedSelector.apply(null, arguments);
  };
  wrappedSelector.gated = gatedSelector;
  wrappedSelector.ungated = ungatedSelector;
  return wrappedSelector;
}